import {Location} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'goto',
  template: ''
})
export class GotoComponent implements OnInit {
  private apiURL = '/api/auth/goto';
  private readonly sysFeatureId: number;

  constructor(private activatedRoute: ActivatedRoute,
              private location: Location) {
    this.sysFeatureId = this.activatedRoute.snapshot.params['sysFeatureId'];
  }

  ngOnInit(): void {
    window.open(this.apiURL + '/' + this.sysFeatureId, '_blank');
    this.location.back();
  }
}
